(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("alt-library", [], factory);
	else if(typeof exports === 'object')
		exports["alt-library"] = factory();
	else
		root["alt-library"] = factory();
})(window, function() {
return 